import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { PrivateAxios } from "../api";

export const fetchPreviewId = createAsyncThunk(
  "perview/fetchPreviewId",
  async (construction_preview_id, { rejectWithValue }) => {
    try {
      const response = await PrivateAxios.post(
        `/api/user/construction/show`,
        { construction_preview_id },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.data.status) {
        return rejectWithValue(response.data.message || "Invalid status.");
      }

      return response.data.data.construction;
    } catch (error) {
      console.error("Error fetching perviews", error.message);
      return rejectWithValue(
        error.response?.data || error.request || "Failed to fetch orders"
      );
    }
  }
);

const initialState = {
  showPreviewId: [],
  status: "idle",
  error: null,
};

const showPreviewIdSlice = createSlice({
  name: "showPreviewId",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPreviewId.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchPreviewId.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.showPreviewId = action.payload;
      })
      .addCase(fetchPreviewId.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default showPreviewIdSlice.reducer;